import React, { useState, useEffect,useRef } from 'react';
import axios from 'axios';

const Device_Addition_Int = () => {
  const [deviceId, setDeviceId] = useState('');
  const [vendorId, setVendorId] = useState('');
  const [vendorOptions, setVendorOptions] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_URL}/api/options`) 
      .then((response) => {
        if (Array.isArray(response.data)) {
          setVendorOptions(response.data);

      // console.error('Unexpected response formatin if', response.data)
        } else {
    //   console.error('Unexpected response format', response.data);
        }
      })
      .catch((error) => {
          //console.error('Error fetching vendor options', error);
        setVendorOptions([]);
      });
  }, []);

  const handleSubmit = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_URL}/api/updateNewDevice`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
           'X-React-Route': window.location.href

        },
        credentials: 'include',
        body: JSON.stringify({
          device_id: deviceId,
          venderType: vendorId,
        }),
      });

      const data = await response.json();

      if (!response.ok || data.success === false) {
        throw new Error(data.message || 'Device registration failed');
      }

      alert(data.message);
    } catch (error) {
     // console.error('Submission Error:', error);
      setErrorMessage(error.message || 'Something went wrong');
    }
  };

  return (
    <div style={{ textAlign: 'center' }}>
     
      <br />
      <table width="30%" align="center">
        <thead>
          <tr className="tableheader">
            <th colSpan={2}>New Device Registration</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Device ID</td>
            {/* <td align="left">
              <input
                type="text"
                name="device_id"
                id="device_id"
                required
                minLength={0}
                maxLength={16}
                pattern=".{10,}"
                title="16 Digits FPS Id"
                value={deviceId}
                onChange={(e) => setDeviceId(e.target.value)}
                onFocus={(e) => e.target.select()} 

              />
            </td> */}


           <td align="left">
      <input
        ref={inputRef}
        type="text"
        name="device_id"
        id="device_id"
        required
        minLength={0}
        maxLength={16}
        pattern=".{10,}"
        title="16 Digits Device ID"
        value={deviceId}
        onChange={(e) => setDeviceId(e.target.value)}
        style={{
          backgroundColor: "white",
          border: "1px solid #ccc",
          padding: "5px 8px",
          fontSize: "14px",
          outline: "none",
        }}
        // Hover → focus
        onMouseEnter={() => {
          if (inputRef.current) {
            inputRef.current.focus();
          }
        }}
        // Focus → border color change & select text
        onFocus={(e) => {
          e.target.style.border = "1px solid #333";
          e.target.select();
        }}
        // Blur → reset border
        onBlur={(e) => {
          e.target.style.border = "1px solid #ccc";
        }}
      />
    </td>


          </tr>
          <tr>
            <td>Vendor</td>
            <td align="left">
              <select
                name="vendor_id"
                id="vendor_id"
                value={vendorId}
                onChange={(e) => setVendorId(e.target.value)}
              >
                <option value="">-- Select Vendor --</option>
                {vendorOptions.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </td>
          </tr>
          <tr>
            <td colSpan={2} align="center">
              <button onClick={handleSubmit} className="button button2">
                Submit
              </button>
              <button onClick={() => window.history.back()} className="button button2">
                Back
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <br></br>
       {errorMessage && (
        <div style={{ color: 'red', fontSize: '14px' }}>{errorMessage}</div>
      )}
    </div>
  );
};

export default Device_Addition_Int;
